import React from 'react';
import { Star } from 'lucide-react';
export function Testimonials() {
  const reviews = [{
    name: "Elena R.",
    text: "A los 10 días mi mandíbula se veía mucho más definida. ¡Increíble!",
    city: "Miami, FL"
  }, {
    name: "Marta S.",
    text: "Ya no me despierto con la cara hinchada. El drenaje funciona de verdad.",
    city: "Madrid, ES"
  }, {
    name: "Lucía M.",
    text: "Mi piel tiene un brillo que no lograba ni con las cremas más caras.",
    city: "CDMX, MX"
  }];
  return <section className="py-20 bg-white" data-id="element-324">
      <div className="max-w-7xl mx-auto px-6" data-id="element-325">
        <h2 className="text-3xl font-heading text-center mb-12 italic" data-id="element-326">Lo que dicen nuestras alumnas...</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-327">
          {reviews.map((rev, i) => <div key={i} className="p-8 bg-[#FFFDD0]/20 rounded-2xl border border-[#FADADD]/50" data-id="element-328">
              <div className="flex mb-4" data-id="element-329">
                {[...Array(5)].map((_, s) => <Star key={s} className="w-4 h-4 text-[#D4AF37] fill-current" data-id="element-330" />)}
              </div>
              <p className="text-gray-700 italic mb-6 font-light" data-id="element-331">"{rev.text}"</p>
              <div data-id="element-332">
                <p className="font-bold text-gray-900 text-sm" data-id="element-333">{rev.name}</p>
                <p className="text-xs text-gray-500" data-id="element-334">{rev.city}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}